import React from "react";
import Form from "../components/Form";

export default function AddNewJob() {
  return <Form />;
}
